<template>
    <section class="form__item__input input" :class="{ 'input--success': invalid == false, 'input--error': invalid }">
        <input type="email" class="input__field input--success" value="" v-model="value"/>
    </section>
</template>

<script>
  export default {
    name: 'EmailInput',
    props: ['settings', 'defaultValue', 'options'],
    methods: {
      update(value){
        this.invalid = this.invalidFormat(value);
        if (value == '') {
          this.invalid = null;
        }
        this.$emit('input', value);
      },
      invalidFormat (email) {
        var re = /(\w(=?@)\w+\.{1}[a-zA-Z]{2,})/i
        return !re.test(email)
      }
    },
    data(){
      return {
        value: this.defaultValue || null,
        invalid: null,
      }
    },
    watch: {
      value(newVal){
        this.update(newVal);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/configurator/EmailInput.vue